<mat-toolbar class="mat-elevation-z3 sticky-toolbar" style="
    z-index: 2;
    position: relative;
    font-family: DM Sans;
    background: white;
    height: 90px;
  ">
  <img routerLink="/home" src="../../assets/simpli/simplilogo2.svg" height="70px" class="logo-new-simpli" />

  <button mat-icon-button (click)="open_menu()" class="icon-menu-desktop">
    <mat-icon>menu</mat-icon>
  </button>

  <div class="flex-toolbar" style="position: relative">
    <div class="logo">
      <button style="z-index: 999999999" mat-icon-button (click)="open_menu()">
        <mat-icon style="color: #1b0943">menu</mat-icon>
      </button>
    </div>

    <span class="example-spacer"></span>

    <div class="user-info">
      <div class="animate__animated animate__fadeIn" style="cursor: pointer; margin-right: 10px"
        (click)="cambiarEmpresa()">
        <div class="name_empresa_toolbar1 animate__animated animate__fadeIn">
          <strong class="animate__animated animate__fadeIn" style="font-size: 17px">¡Hola {{ name }}!</strong>
        </div>
        <div class="name_empresa_toolbar animate__animated animate__fadeIn" style="width: 200px">
          @if (loadingCompany == false) {
          <input readonly class="no-input nombre-empresa" value="{{ this.company_selected }}" />
          }
          @if (loadingCompany == true) {
          <skeleton-loader></skeleton-loader>
          }
        </div>
      </div>
    </div>

    <div class="user-icons">
      <button mat-icon-button class="btn-icon-toolbar" matTooltip="Mis credenciales" (click)="openDialog()">
        <span class="material-symbols-outlined icon-toolbar">enhanced_encryption</span>
      </button>

      <button mat-icon-button [matMenuTriggerFor]="menu" class="btn-icon-toolbar">
        <span class="material-symbols-outlined icon-toolbar">person</span>
      </button>

      <mat-menu #menu="matMenu" xPosition="before" yPosition="below" class="menu-user-simpli">
        <button mat-menu-item routerLink="/home/info">
          <span class="material-symbols-outlined icon-simpli">manage_accounts</span>
          <span style="color: var(--simpli-color5); font-family: 'DM Sans'">Administrar mi cuenta</span>
        </button>

        <button mat-menu-item (click)="openExecutiveInfo()">
          <span class="material-symbols-outlined icon-simpli">support_agent</span>
          <span style="color: var(--simpli-color5); font-family: 'DM Sans'">Contactar a mi Ejecutivo</span>
        </button>

        @if (this.rol != 'conf' && this.rol != 'prpa') {
        <button mat-menu-item (click)="cambiarEmpresa()">
          <span class="material-symbols-outlined icon-simpli">apartment</span>
          <span style="color: var(--simpli-color5); font-family: 'DM Sans'">Gestionar otra Empresa</span>
        </button>
        }

        <button mat-menu-item (click)="gestionarNotificaciones()">
          <span class="material-symbols-outlined icon-simpli">notifications</span>
          <span style="color: var(--simpli-color5); font-family: 'DM Sans'">Gestionar Notificaciones</span>
        </button>

        @if(modeProd?.ocultar_en_prod() == false){
          <button mat-menu-item (click)="beta_cliente()" style="background: var(--simpli-primary);">
            <span class="material-symbols-outlined icon-simpli">auto_awesome</span>
            <span style="color: var(--simpli-color5); font-family: 'DM Sans'">Beta Portal Cliente</span>
          </button>
        }

        <button mat-menu-item (click)="logout()">
          <span class="material-symbols-outlined icon-simpli">logout</span>
          <span style="color: var(--simpli-color5); font-family: 'DM Sans'">Cerrar Sesión</span>
        </button>
        
      </mat-menu>

      <button mat-icon-button [matMenuTriggerFor]="notificaciones" class="btn-icon-toolbar"
        [matBadge]="totalNotificaciones == 0 ? '' : totalNotificaciones" matBadgeColor="warn" matBadgeOverlap="true"
        (click)="readNotifications()">
        <span class="material-symbols-outlined icon-toolbar">notifications</span>
      </button>

      <mat-menu #notificaciones="matMenu" xPosition="before" yPosition="below" class="menu-user-simpli add_factoring">
        @if (!loadingNotificaciones && notificacionesSimpli.length > 0) {
        <div class="animate__animated animate__fadeIn animate__faster">
          @for (notif of notificacionesSimpli; track notif) {
          <a mat-menu-item (click)="learweas(notif)" class="notification-item" style="width: 100%">
            <div class="notification-item-icon">
              <span class="material-symbols-outlined">{{ getNotifMaterialIcon(notif.icon) }}</span>
            </div>
            <div class="notification-item-body">
              <div class="notification-item-text">
                <span [innerHTML]="notif.title"></span>
              </div>
              <div class="notification-item-date">
                <small>
                  {{ notif.date_created | date : "dd-MM-YYYY, HH:MM" }}
                </small>
              </div>
            </div>
          </a>
          }
        </div>
        }

        @if (loadingNotificaciones) {
        <div style="text-align: center">
          <div mat-menu-item class="notification-item-spinner" style="text-align: center; justify-content: center">
            <span class="material-symbols-outlined mat-spin">progress_activity</span>
          </div>
        </div>
        }

        @if (!loadingNotificaciones && notificacionesSimpli.length == 0) {
        <div>
          <div mat-menu-item class="notification-item-no-info">
            No hay notificaciones.
          </div>
        </div>
        }
      </mat-menu>
    </div>
  </div>

  &nbsp; &nbsp;
</mat-toolbar>

<app-promo-banner></app-promo-banner>

<mat-sidenav-container style="min-height: 190vh" [hasBackdrop]="hasBackdrop" (backdropClick)="close_menu($event)"
  style="background: #f8f8f8">
  @if (display) {
  <mat-sidenav (mouseleave)="mouseleave($event)" style="background: white"
    class="lale mat-elevation-z3 animate__animated animate__fadeIn animate__faster menusimpli" #sidenav [(mode)]="mode"
    [(opened)]="opened">
    <app-menu-simpli [menu_cliente]="menu_cliente" [menu_confirming_pronto_pago]="menu_confirming_pronto_pago"
      [parent]="this" [mode]="mode"></app-menu-simpli>
  </mat-sidenav>
  }

  <mat-sidenav-content style="
      min-height: 100vh;
      overflow: hidden;
      background: var(--simpli-background);
    ">


    <div class="row row_main"></div>

    @if (showTool) {
    <div class="tooltip_arrayan {{ this.tool_class }}" style="display: none">
      <div (click)="close_tool()" class="close_tooltip">&times;</div>
      <div class="tooltip_arrayan_title">
        {{ this.tool_title }}
      </div>
      <div class="tooltip_arrayan_body">
        {{ this.tool_body }}
      </div>
      <a href="{{ this.tool_link }}" class="tooltip_arrayan_link">
        {{ this.tool_link_text }}
      </a>
    </div>
    }

    @if (isUserDataCharged) {
    <app-mirai-cliente [initials]="initials" [full_name]="full_name" [avatar]="avatar"></app-mirai-cliente>
    }

    <!--Esto no funciona y hace llamado recursivo-->
    <!-- <app-chat-bubble *ngIf="activate_chat"></app-chat-bubble> -->
    <router-outlet> </router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>